<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <!-- Título  -->
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-toolbar-title>Editar Expediente</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <!-- <h2 class="font-weight-light blue--text">id: {{ expedienteSelected.idx }}</h2> -->
              <!-- <v-divider class="mx-2" inset vertical></v-divider> -->
              <h2 class="font-weight-light">
                Catastro:
                <a :href="linkCatastro" target="_blanc">{{
                  expedienteSelected.detalle.refCatastro
                }}</a>
              </h2>
              <v-spacer></v-spacer>
              <v-btn @click="inmueblesEdit" class="success">Inmuebles</v-btn>
              <!-- <v-btn v-if="inmueblesForm && inmueblesForm.length > 0" @click="dialogListForms = true" class="error">List. Provisional</v-btn> -->
              <v-spacer></v-spacer>
              <v-btn @click="addAdmin" class="secondary"
                >Nuevo Administrador</v-btn
              >
              <v-btn @click="addGestor" class="secondary">Nuevo Gestor</v-btn>
              <!-- <v-btn class="secondary">Nuevo Estado</v-btn> -->
              <!-- adminPropietarios -->
              <v-btn @click="adminPropietarios" class="error"
                >Admin Propietarios</v-btn
              >
              <v-btn @click="listaPropietarios" class="primary"
                >Lista Propietarios</v-btn
              >
            </v-card-title>
          </v-card>
        </v-flex>

        <!-- CheckList Documentación -->
        <v-flex d-flex xs12 sm6>
          <v-card>
            <v-container
              v-if="
                expedienteSelected.detalle.provincia &&
                  expedienteSelected.detalle.provincia === '28'
              "
              fluid
              grid-list-md
            >
              <v-flex xs12 sm6>
                <v-autocomplete
                  v-model="expedienteSelected.detalle.tipoExpte"
                  :items="tiposExpedientes"
                  item-text="text"
                  item-value="value"
                  label="Tipo de Expediente"
                  persistent-hint
                >
                </v-autocomplete>
              </v-flex>
            </v-container>
            <v-container
              v-if="
                expedienteSelected.detalle.tipoExpte &&
                  expedienteSelected.detalle.tipoExpte === 1
              "
              fluid
              grid-list-md
            >
              <v-layout row justify-space-around fill-height align-start>
                <v-flex xs12 sm6>
                  <v-list subheader>
                    <v-subheader>Documentos Solicitud</v-subheader>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.madAscensor
                          "
                        ></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Ascensor Nuevo</v-list-tile-title>
                        <v-list-tile-sub-title
                          >Antes de 1994</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.madAmianto
                          "
                        ></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Amianto</v-list-tile-title>
                        <v-list-tile-sub-title
                          >Antes de 1994</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="expedienteSelected.detalle.documentos.mad607"
                        ></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >Pertenece a los 607</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <!-- <v-subheader>APIRU (antes de 1994)</v-subheader>
                                        <v-list-tile avatar>
                                            <v-list-tile-action>
                                                <v-radio-group v-model="expedienteSelected.detalle.documentos.apiru" row>
                                                    <v-radio label="SI" value="2"></v-radio>
                                                    <v-radio class="ml-2" label="NO" value="1"></v-radio>
                                                    <v-radio class="ml-2" label="No se sabe" value="0"></v-radio>
                                                </v-radio-group>
                                            </v-list-tile-action>
                                        </v-list-tile> -->

                    <div class="orange lighten-4 pt-2 pl-2 mb-1">
                      <span class="mb-0 pt-2">APIRU</span><br />
                      <span class="mt-1 pt-1 caption grey--text"
                        >antes de 1994</span
                      >
                      <v-list-tile avatar>
                        <v-list-tile-action>
                          <v-radio-group
                            v-model="
                              expedienteSelected.detalle.documentos.madApiru
                            "
                            row
                          >
                            <v-radio label="SI" value="2"></v-radio>
                            <v-radio
                              class="ml-2"
                              label="NO"
                              value="1"
                            ></v-radio>
                            <v-radio
                              class="ml-2"
                              label="No se sabe"
                              value="0"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-tile-action>
                      </v-list-tile>
                    </div>

                    <div class="blue lighten-5 pt-2 pl-2 mb-1">
                      <span class="mb-0 pt-2">Resto 5.c (antes de 1980)</span
                      ><br />
                      <span class="mt-1 pt-1 caption grey--text"
                        >Valor catastral menos de 935€/m2</span
                      >
                      <v-list-tile avatar>
                        <v-list-tile-action>
                          <v-radio-group
                            v-model="
                              expedienteSelected.detalle.documentos.madResto
                            "
                            row
                          >
                            <v-radio label="SI" value="2"></v-radio>
                            <v-radio
                              class="ml-2"
                              label="NO"
                              value="1"
                            ></v-radio>
                            <v-radio
                              class="ml-2"
                              label="No se sabe"
                              value="0"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-tile-action>
                      </v-list-tile>
                    </div>

                    <div class="green lighten-4 pt-2 pl-2 mb-1">
                      <span class="mb-0 pt-2">Plan Madre</span><br />
                      <v-list-tile avatar>
                        <v-list-tile-action>
                          <v-radio-group
                            v-model="
                              expedienteSelected.detalle.documentos.madPlanMadre
                            "
                            row
                          >
                            <v-radio label="SI" value="2"></v-radio>
                            <v-radio
                              class="ml-2"
                              label="NO"
                              value="1"
                            ></v-radio>
                            <v-radio
                              class="ml-2"
                              label="No se sabe"
                              value="0"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-tile-action>
                      </v-list-tile>
                    </div>

                    <div class="red lighten-4 pt-2 pl-2 mb-1">
                      <span class="mb-0 pt-2">ARRU</span><br />
                      <v-list-tile avatar>
                        <v-list-tile-action>
                          <v-radio-group
                            v-model="
                              expedienteSelected.detalle.documentos.madArru
                            "
                            row
                          >
                            <v-radio label="SI" value="2"></v-radio>
                            <v-radio
                              class="ml-2"
                              label="NO"
                              value="1"
                            ></v-radio>
                            <v-radio
                              class="ml-2"
                              label="No se sabe"
                              value="0"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-tile-action>
                      </v-list-tile>
                    </div>
                  </v-list>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-list subheader>
                    <v-subheader>Otros Documentos</v-subheader>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.informeTecnico
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>Informe Técnico</v-list-tile-title>
                        <!-- <v-list-tile-sub-title><v-text-field label="Fecha" v-model="expedienteSelected.detalle.documentos.fechaSolicitud"></v-text-field></v-list-tile-sub-title> -->
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.ieeObligado
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>IEE Obligado</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.ieeTenemos
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>IEE Tenemos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos
                              .obrasEficiencia
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >Obras Eficiencia Art.12</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos
                              .obrasConservacion
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >Obras Conservación Art. 17 A y B</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.obrasSeguridad
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >Obras Seguridad y Accesibilidad Art.
                          17.2</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="expedienteSelected.detalle.documentos.pem"
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>PEM</v-list-tile-title>
                        <v-list-tile-sub-title
                          >Gtos. Generales y Bnfo.
                          Industrial</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container v-else fluid grid-list-md>
              <v-layout row justify-space-around fill-height align-start>
                <v-flex xs12 sm6>
                  <v-list subheader>
                    <v-subheader>Documentos Solicitud</v-subheader>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.solicitud_111
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>1.1.1 Solicitud</v-list-tile-title>
                        <!-- <v-list-tile-sub-title><v-text-field label="Fecha" v-model="expedienteSelected.detalle.documentos.fechaSolicitud"></v-text-field></v-list-tile-sub-title> -->
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.grafica_112
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >1.1.2 Consulta Gráfica Catastro</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.anexoII_113
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >1.1.3 Anexo II Declaración
                          Responsable</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.iban_114
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >1.1.4 Certificado IBAN</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.cif_121
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>1.2.1 Copia CIF</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.anexoI_122
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >1.2.2 Anexo I Certificado de
                          Acuerdo</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.anexoI_123
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >1.2.3 Anexo I Relación de Locales y
                          Viviendas</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos
                              .residencial_125
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >1.2.5 Justifica 70% Residencial</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos
                              .empadronamientos_126
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >1.2.6 Se tienen los empadronamientos
                          mínimos.</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >Mínimo
                          {{
                            expedienteSelected.detalle.documentos
                              .empadronamientosMinNumber || "?"
                          }}
                          empadronados</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-list subheader>
                    <v-subheader>Otros Documentos</v-subheader>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.informeTecnico
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>Informe Técnico</v-list-tile-title>
                        <!-- <v-list-tile-sub-title><v-text-field label="Fecha" v-model="expedienteSelected.detalle.documentos.fechaSolicitud"></v-text-field></v-list-tile-sub-title> -->
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.ieeObligado
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>IEE Obligado</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.ieeTenemos
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>IEE Tenemos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos
                              .obrasEficiencia
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >Obras Eficiencia Art.12</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos
                              .obrasConservacion
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >Obras Conservación Art. 17 A y B</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="
                            expedienteSelected.detalle.documentos.obrasSeguridad
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          >Obras Seguridad y Accesibilidad Art.
                          17.2</v-list-tile-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <!-- Botonera -->
        <!-- <v-flex xs6>
                    <v-card>
                        <v-card-title>
                            <v-btn @click="inmueblesEdit" class="success">Inmuebles</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="addAdmin" class="primary">Nuevo Administrador</v-btn>
                            <v-btn @click="addGestor" class="primary">Nuevo Gestor</v-btn>
                            <v-btn class="primary">Nuevo Estado</v-btn>
                        </v-card-title>
                    </v-card>
                </v-flex> -->

        <!-- Datos -->
        <v-flex d-flex xs12 sm6>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout column justify-space-around fill-height align-start>
                <v-flex xs12>
                  <v-form>
                    <v-card>
                      <v-card-text>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex xs9>
                              <v-text-field
                                v-model="
                                  expedienteSelected.detalle.nombreComunidad
                                "
                                label="Nombre de la Comunidad de Propietarios"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                              <v-text-field
                                v-model="expedienteSelected.detalle.customId"
                                label="Identificador Interno"
                                :placeholder="placeholderCustomId"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="expedienteSelected.detalle.direccion"
                            label="Dirección"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex>
                          <v-flex xs12 sm2>
                            <v-text-field
                              v-model="expedienteSelected.detalle.cp"
                              label="C.P."
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4>
                            <!-- <v-text-field v-model="expedienteSelected.detalle.provincia" label="Provincia" ></v-text-field> -->
                            <v-autocomplete
                              v-model="expedienteSelected.detalle.provincia"
                              :items="provinciaSelect"
                              item-text="text"
                              item-value="value"
                              label="Provincia"
                              @change="changeProvincia"
                              persistent-hint
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <!-- <v-text-field v-model="expedienteSelected.detalle.localidad" label="Localidad" ></v-text-field> -->
                            <v-autocomplete
                              v-model="expedienteSelected.detalle.localidad"
                              :items="municipioSelect"
                              item-text="text"
                              item-value="value"
                              label="Localidad"
                              persistent-hint
                            >
                            </v-autocomplete>
                          </v-flex>
                        </v-flex>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="expedienteSave">
                          Guardar
                        </v-btn>
                        <v-btn color="danger" @click="expedienteReset">
                          Cancelar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </v-flex>

                <!-- Gestor, Administrador, Técnico, ... -->
                <v-flex xs12>
                  <v-form>
                    <v-card>
                      <v-card-text>
                        <v-flex d-flex>
                          <v-flex xs12>
                            <!-- <v-text-field label="Administrador" ></v-text-field> -->
                            <v-autocomplete
                              v-model="expedienteSelected.detalle.admon"
                              :items="adminfincas"
                              item-text="name"
                              item-value="idx"
                              label="Administrador de Fincas"
                              persistent-hint
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12>
                            <!-- <v-text-field label="Gestor" ></v-text-field> -->
                            <v-autocomplete
                              v-model="expedienteSelected.detalle.gestor"
                              :items="gestores"
                              item-text="name"
                              item-value="idx"
                              label="Gestor Responsable"
                              persistent-hint
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12>
                            <!-- <v-text-field label="Estado" ></v-text-field> -->
                            <v-autocomplete
                              v-model="expedienteSelected.detalle.status"
                              :items="expteStatus"
                              label="Estado Expediente"
                              persistent-hint
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12>
                            <!-- <v-text-field label="Estado" ></v-text-field> -->
                            <v-text-field
                              prefix="€"
                              type="number"
                              v-model="expedienteSelected.detalle.honorarios"
                              label="Honorarios G.A."
                            >
                            </v-text-field>
                          </v-flex>
                        </v-flex>
                      </v-card-text>
                    </v-card>

                    <v-card color="red lighten-5">
                      <v-card-text>
                        <v-flex xs12>
                          <v-textarea
                            v-model="expedienteSelected.detalle.notas"
                            label="Notas internas"
                          ></v-textarea>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                    <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="expedienteSave">
                          Guardar
                        </v-btn>
                        <v-btn color="danger" @click="expedienteReset">
                          Cancelar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <!-- Gestor, Administrador, Técnico, ... -->
        <!-- <v-flex d-flex xs12 sm6>
                    <v-form>
                        <v-card>
                            <v-card-text>
                                <v-flex d-flex>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            v-model="expedienteSelected.detalle.admon"
                                            :items="adminfincas"
                                            item-text="name"
                                            item-value="idx"
                                            label="Administrador de Fincas"
                                            persistent-hint>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            v-model="expedienteSelected.detalle.gestor"
                                            :items="gestores"
                                            item-text="name"
                                            item-value="idx"
                                            label="Gestor Responsable"
                                            persistent-hint>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            v-model="expedienteSelected.detalle.status"
                                            :items="expteStatus"
                                            label="Estado Expediente"
                                            persistent-hint>
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-card-text>
                            
                        </v-card>

                        <v-card>
                            <v-card-text>
                                <v-flex xs12>
                                    <v-textarea v-model="expedienteSelected.detalle.notas" label="Notas" ></v-textarea>
                                </v-flex>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="success" @click="expedienteSave">
                                    Guardar
                                </v-btn>
                                <v-btn color="danger" @click="expedienteReset">
                                    Cancelar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-flex> -->
      </v-layout>
    </v-container>

    <!-- Usuarios -->
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="red">
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Usuario</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialog = false">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-list three-line subheader>
            <v-subheader>User Controls</v-subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Content filtering</v-list-tile-title>
                <v-list-tile-sub-title
                  >Set the content filtering level to restrict apps that can be
                  downloaded</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Password</v-list-tile-title>
                <v-list-tile-sub-title
                  >Require password for purchase or use password to restrict
                  purchase</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list three-line subheader>
            <v-subheader>General</v-subheader>
            <!-- <v-list-tile avatar>
                                <v-list-tile-action>
                                <v-checkbox v-model="notifications"></v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title>Notifications</v-list-tile-title>
                                <v-list-tile-sub-title>Notify me about updates to apps or games that I downloaded</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile> -->
            <v-list-tile avatar>
              <v-list-tile-action>
                <!-- <v-checkbox v-model="sound"></v-checkbox> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Sound</v-list-tile-title>
                <v-list-tile-sub-title
                  >Auto-update apps at any time. Data charges may
                  apply</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-action>
                <!-- <v-checkbox v-model="widgets"></v-checkbox> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Auto-add widgets</v-list-tile-title>
                <v-list-tile-sub-title
                  >Automatically add home screen widgets</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- Catastro - Inmuebles -->
    <!-- <v-dialog
            v-model="catastroListDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable>
            <v-card tile>
                <v-toolbar card dark color="green">
                    <v-btn icon dark @click.native="catastroListDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        Inmuebles Catastro
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                        <h2 >{{expedienteSelected.detalle.refCatastro}}</h2>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark flat @click.native="catastroListDialog = false">Guardar</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <admin-catastro :catastroSelect="expedienteSelected.detalle.refCatastro"></admin-catastro>
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog> -->

    <v-snackbar v-model="hecho" :timeout="hechoTimeOut" top>
      Hecho !!
      <v-btn color="pink" flat @click="hecho = false">
        cerrar
      </v-btn>
    </v-snackbar>

    <v-layout row justify-center>
      <v-dialog v-model="dialogListForms" fullscreen hide-overlay transition="dialog-bottom-transition">
        <listForms :refCat="expedienteSelected.detalle.refCatastro" @closeDialog="dialogListForms = false" />
      </v-dialog>
    </v-layout>
    <template v-if="debug">
      <!-- 9438601UF6693N -->
      <!-- <pre>{{ expedienteSelected }}</pre> -->
      <pre>{{ inmueblesForm }}</pre>
      <!-- <pre>{{ propiForm }}</pre> -->
    </template>
  </div>
</template>

<script>
// import AdminCatastro from "./admin-catastro";
import { mapState, mapGetters, mapActions } from "vuex";
import listForms from "@/components/propietarios/Admin-propietarios-list.vue";

export default {
  name: "AdminExpedientesEdit",
  components: {
    listForms
    // AdminCatastro
  },
  data() {
    return {
      dialogListForms: false,
      dialog: false,
      addUserRol: "",
      catastroListDialog: false,
      expedienteSelected: false,
      hecho: false,
      hechoTimeOut: 6000,
      documentosData: {
        solicitud_111: false,
        grafica_112: false,
        anexoII_113: false,
        iban_114: false,
        cif_121: false,
        anexoI_122: false,
        anexoI_123: false,
        residencial_125: false,
        empadronamientos_126: false,
        empadronamientosMinNumber: 0,
        informeTecnico: false,
        ieeObligado: false,
        ieeTenemos: false,
        obrasEficiencia: false,
        obrasConservacion: false,
        obrasSeguridad: false
      }
    };
  },
  watch: {},
  created() {
    this.seleccionarExpte();
    this.changeProvincia();
  },
  beforeDestroy() {
    console.log('Saliendo de admin-pages/admin-expedientesEdit  !!!');
    // this.unSetCatastroForm();
  },
  methods: {
    ...mapActions(["setCatastroForm", "unSetCatastroForm"]),
    listaPropietarios() {
      this.$router.push(
        `/dashboard/propietarios/${this.expedienteSelected.detalle.refCatastro}`
      );
    },
    adminPropietarios() {
      this.$router.push(
        `/dashboard/adminpropietarios/${this.expedienteSelected.detalle.refCatastro}`
      );
    },
    inmueblesEdit() {
      // catastroListDialog = true
      this.$router.push(
        `/dashboard/inmuebles/${this.expedienteSelected.detalle.refCatastro}`
      );
    },
    changeProvincia() {
      this.$store.dispatch(
        "setMunicipios",
        this.expedienteSelected.detalle.provincia
      );
    },
    addAdmin() {
      this.dialog = true;
      this.addUserRol = "administrador";
    },
    addGestor() {
      this.dialog = true;
      this.addUserRol = "gestor";
    },
    addPropietario() {
      this.dialog = true;
      this.addUserRol = "propietario";
    },
    expedienteReset() {
      // consoleLog('Cancelar edición expediente')
    },
    seleccionarExpte() {
      const idx = this.$route.params.id;
      this.expedienteSelected = this.$store.getters.getExpedienteSelected(idx);
      if (!this.expedienteSelected.detalle.documentos) {
        this.expedienteSelected.detalle.documentos = this.documentosData;
      }
      this.navegationControl.expedienteEdit = this.expedienteSelected.detalle;
      this.navegationControl.expedienteEdit.id = idx;
      this.setCatastroForm(this.expedienteSelected.detalle.refCatastro);
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    expedienteSave() {
      if (this.expedienteSelected) {
        const datos = {
          idx: this.expedienteSelected.idx,
          data: this.expedienteSelected.detalle
        };
        this.$store.dispatch("updateExpedientes", datos);
        this.hecho = true;
      }
    }
  },
  computed: {
    ...mapState(["navegationControl"]),
    ...mapGetters(["inmueblesForm", "propietariosForm", "debug"]),
    propiForm() {
      if (!this.inmueblesForm) {
        return [];
      }
      return this.inmueblesForm.map(i => {
        return {
          id: i.id,
          propietarios: i.propietarios
        };
      });
    },
    tiposExpedientes() {
      return [
        {
          value: 0,
          text: "PEV - Murcia"
        },
        {
          value: 1,
          text: "MAD-RE - Madrid"
        }
      ];
    },
    placeholderCustomId() {
      const id = this.expedienteSelected.idx;
      const ini = id.substr(0, 2);
      const end = id.substr(2, 4);
      return `${ini}_${end}_xxx`;
    },
    linkCatastro() {
      const p1 = this.expedienteSelected.detalle.refCatastro.substr(0, 7);
      const p2 = this.expedienteSelected.detalle.refCatastro.substr(7, 14);
      return `https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?RC1=${p1}&RC2=${p2}`;
    },
    comunidadSelect() {
      return this.$store.getters.getComunidadId(
        this.expedienteSelected.detalle.ca.idx
      );
    },
    municipioSelect() {
      return this.$store.getters.getMunicipiosSelect;
    },
    provinciaSelect() {
      return this.$store.getters.getProvinciasSelect.filter(item =>
        this.comunidadSelect.provincias.includes(parseInt(item.value))
      );
    },
    expteStatus() {
      return this.$store.getters.getExpedientesStatus;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    adminfincasObject() {
      return this.$store.getters.getAdminFincasObject;
    },
    adminfincas() {
      return this.$store.getters.getAdminFincas; // getAdminFincas
    },
    gestoresObject() {
      return this.$store.getters.getGestoresObject;
    },
    gestores() {
      return this.$store.getters.getGestores;
    }
  }
};
</script>
